/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
function throttle(fn, wait = 300) {
    let throttleTimeoutId = -1;
    let tick = false;
  
    return () => {
        clearTimeout(throttleTimeoutId);
        throttleTimeoutId = setTimeout(fn, wait);
  
        if (!tick) {
            fn.call();
            tick = true;
            setTimeout(() => {
                tick = false;
            }, wait);
        }
    };
}
  
if (!customElements.get('sticky-atc')) {   
    customElements.whenDefined('product-form').then(() => {
        class StickyAtc extends customElements.get('product-form') {
            constructor() {
                super();
  
                this.section = this.closest('.section-main-product');
                this.mainProductForm = this.section.querySelector('.product-form');
                this.buyButtons = this.section.querySelector('.buy-buttons-row');
                this.imageContainer = this.querySelector('.sticky-atc__image');
                this.variantContainer = this.querySelector('.sticky-atc__details__variant');
                this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
                this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
  
                this.throttledOnScroll = throttle(StickyAtc.handleScroll.bind(this));
                window.addEventListener('scroll', this.throttledOnScroll);
  
                this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
                this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));
  
                this.updateImage();
            }
  
            disconnectedCallback() {
                window.removeEventListener('scroll', this.throttledOnScroll);
            }
  
            /**
            * Handles submission of the product form.
            * @param {object} evt - Event object.
            */
            async handleSubmit(evt) {
                evt.preventDefault();
  
                const mainForm = this.section.querySelector('form.shopify-product-form[action="/cart/add"]');
                if (!mainForm) return;
  
                const variantId = mainForm?.querySelector('input[name="id"]')?.value;
                
                if (!variantId) {
                    const target = this.section.querySelector('#product-info');
                    if (target && target.offsetParent) {
                        evt.preventDefault();
                        theme.scrollToRevealElement(target);
                    }
                    return;
                }
  
                try {
                    // Copy data and ensure correct form action
                    this.form.action = '/cart/add';
                    this.form.method = 'post';
                    this.form.querySelectorAll('[data-copied]').forEach((el) => el.remove());
                    
                    const formData = new FormData(mainForm);
                    const data = {
                        items: [{
                            id: parseInt(variantId, 10),
                            quantity: 1,
                            properties: {}
                        }]
                    };
  
                    // Submit using the same format as add-to-cart.js
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: JSON.stringify(data)
                    });
  
                    if (!response.ok) throw new Error(response.statusText);
                    const responseData = await response.json();
  
                    // Handle drawer using the same logic from add-to-cart.js
                    $('#cart-summary-overlay #shop-more').triggerHandler('click');
                    
                    const cartPopupTemplate = [
                        '<div id="cart-summary-overlay" class="cart-summary-overlay">',
                        '<div class="cart-summary-overlay__row-head">',
                            '<div class="cart-summary-overlay__column-image">',
                                '<div class="cart-summary-overlay__column-title">Product</div>',
                            '</div>',
                            '<div class="cart-summary-overlay__column-item">',
                                '<div class="cart-summary-overlay__column-title">Item</div>',
                            '</div>',
                            '<div class="cart-summary-overlay__column-price-region">',
                                '<div class="cart-summary-overlay__column-price">',
                                    '<div class="cart-summary-overlay__column-title">Price</div>',
                                '</div>',
                                '<div class="cart-summary-overlay__column-quantity">',
                                    '<div class="cart-summary-overlay__column-title">Quantity</div>',
                                '</div>',
                                '<div class="cart-summary-overlay__column-total">',
                                    '<div class="cart-summary-overlay__column-title">Total</div>',
                                '</div>',
                            '</div>',
                        '</div>',
                        '<div class="cart-summary-overlay__row-body">',
                            '<div class="cart-summary-overlay__column-image">',
                                '<img src="[[image_url]]" alt="[[encoded-title]]" />',
                            '</div>',
                            '<div class="cart-summary-overlay__column-item">',
                                '<div class="cart-summary-overlay__title">[[title]]</div>',
                                '[[variants]]',
                                '<div class="cart-summary-overlay__mobile-price-row">',
                                    '<div class="cart-summary-overlay__mobile-unit-price">[[unit_price]]</div>',
                                    '<div class="cart-summary-overlay__mobile-quantity">Quantity: <span class="cart-summary-overlay__quantity">[[quantity]]</span></div>',
                                    '<div class="cart-summary-overlay__mobile-line-price">[[line_price]]</div>',
                                '</div>',
                            '</div>',
                            '<div class="cart-summary-overlay__column-price-region">',
                                '<div class="cart-summary-overlay__column-price">',
                                    '<span class="cart-summary-overlay__unit-price">[[unit_price]]</span>',
                                '</div>',
                                '<div class="cart-summary-overlay__column-quantity">',
                                    '<span class="cart-summary-overlay__quantity">[[quantity]]</span>',
                                '</div>',
                                '<div class="cart-summary-overlay__column-total">',
                                    '<div class="cart-summary-overlay__line-price">[[line_price]]</div>',
                                    '[[line_discount]]',
                                '</div>',
                            '</div>',
                        '</div>',
                        '<div class="cart-summary-overlay__actions">',
                            '<a id="shop-more" class="button altcolour" href="#">Continue shopping</a>',
                            '<a class="button to-cart" href="/cart">View cart</a>',
                        '</div>',
                    ].join('');
  
                    // Generate variant HTML if needed
                    let variantHtml = '';
                    console.log('Checking variant title:', responseData.items[0].variant_title);
  
                    if (responseData.items[0].variant_title) {
                        const productId = this.form.dataset.productId;
                        console.log('Product ID:', productId);
                        
                        const productJSONElement = document.getElementById('ProductJson-' + productId);
                        console.log('Product JSON Element:', productJSONElement);
                        
                        // Try multiple ways to get product data
                        const productJSON = 
                            theme.productData?.[productId] || 
                            (productJSONElement ? JSON.parse(productJSONElement.innerHTML) : null) ||
                            JSON.parse(document.getElementById(`ProductJson-${this.dataset.section}`)?.innerHTML || '{}');
                            
                        console.log('Product JSON:', productJSON);
                        
                        if (productJSON && productJSON.options) {
                            console.log('Product Options:', productJSON.options);
                            console.log('Variant Title Parts:', responseData.items[0].variant_title.split(' / '));
                            
                            for (let i = 0; i < productJSON.options.length; i++) {
                                variantHtml += [
                                    '<div class="cart-summary-overlay__variant">',
                                        '<span class="cart-summary-overlay__variant-option">',
                                            productJSON.options[i],
                                        '</span>',
                                        '<span class="cart-summary-overlay__variant-value">',
                                            responseData.items[0].variant_title.split(' / ')[i],
                                        '</span>',
                                    '</div>'
                                ].join('');
                            }
                            console.log('Generated Variant HTML:', variantHtml);
                        } else {
                            console.log('No product options found in JSON');
                        }
                    }
  
                    let cartShadeHTML = cartPopupTemplate;
                    cartShadeHTML = cartShadeHTML.replace('[[title]]', responseData.items[0].product_title);
                    cartShadeHTML = cartShadeHTML.replace('[[encoded-title]]', responseData.items[0].product_title.replace(/"/g, '&quot;').replace(/&/g, '&amp;'));
                    cartShadeHTML = cartShadeHTML.replace('[[variants]]', variantHtml);
                    cartShadeHTML = cartShadeHTML.replace(/\[\[quantity\]\]/g, responseData.items[0].quantity);
                    cartShadeHTML = cartShadeHTML.replace('[[image_url]]', theme.Shopify.formatImage(responseData.items[0].image, '170x'));
                    cartShadeHTML = cartShadeHTML.split('[[unit_price]]').join(theme.Shopify.formatMoney(responseData.items[0].price, theme.money_format));
                    cartShadeHTML = cartShadeHTML.split('[[line_price]]').join(theme.Shopify.formatMoney(responseData.items[0].line_price, theme.money_format));
                    cartShadeHTML = cartShadeHTML.split('[[line_discount]]').join('');
                    
                    const $cartShade = $(cartShadeHTML);
  
                    $cartShade.find('#shop-more').bind('click', function() {
                        $cartShade.animate({
                            top: -$cartShade.outerHeight()
                        }, 500, function() {
                            $(this).remove();
                        });
                    });
  
                    $cartShade.prependTo('body').css('top', -$cartShade.outerHeight()).animate({
                        top: 0
                    }, 500);
  
                    $(window).off('.ajaxAddScroll').on('scroll.ajaxAddScroll', function() {
                        $('#cart-summary-overlay #shop-more').triggerHandler('click');
                    });
  
                } catch (error) {
                    console.error('Error adding to cart:', error);
                }
            }
  
            /**
            * Determine visibility after scroll.
            */
            static handleScroll() {
                console.log('handling scroll')
                
                this.classList.toggle(
                    'sticky-atc--out',
                    this.buyButtons.getBoundingClientRect().top >= -100
                );
  
                document.body.classList.toggle(
                    'scrolled-to-bottom',
                    window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
                );
            }
  
            /**
            * Handle a change in variant on the page.
            * @param {Event} evt - Variant change event dispatched by variant-picker.
            */
            onVariantChange(evt) {
                const idInput = this.form?.querySelector('[name="id"]');
  
                if (evt.detail.variant) {
                    this.variantTitle.textContent = evt.detail.variant.title;
                    this.variantContainer.hidden = false;
                    if (idInput) idInput.value = evt.detail.variant.id;
                } else {
                    this.variantContainer.hidden = true;
                    this.variantTitle.textContent = '';
                    if (idInput) idInput.value = '';
                }
  
                this.updateImage();
                this.updateAddToCartButton(evt.detail.variant);
                this.setErrorMsgState();
            }
  
            /**
            * Updates the image.
            */
            updateImage() {
                const mainImage = this.section.querySelector('.media-gallery .main-image .slider__item.is-active .product-media img');
  
                if (mainImage) {
                    this.imageContainer.innerHTML = mainImage.outerHTML;
                } else {
                    this.imageContainer.textContent = '';
                }
            }
  
            /**
            * Updates the "Add to Cart" button label and status.
            * @param {object} variant - Current variant object.
            */
            updateAddToCartButton(variant) {
                if (!this.submitBtn) return;
  
                const variantAvailable = variant && variant.available;
                const unavailableStr = variant
                    ? theme.strings.noStock : this.submitBtn.dataset.unavailableText;
  
                this.submitBtn.textContent = variantAvailable
                    ? this.submitBtn.dataset.addToCartText
                    : unavailableStr;
            }
        }
  
        customElements.define('sticky-atc', StickyAtc);
    });
}
  